module.exports = __webpack_public_path__ + "img/logo-icon-11.670af91b.png";